import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { toNumberString } from '@delmonicos/shared-sdk/libs/core/src/utils/formatters/number.formatters';
import { TransactionReportsEcologyStatisticsModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction-report/transaction-reports-ecology-statistics.model';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import * as css from '@app/feature/statistics/statistics.module.scss';

interface EmissionsAvoidedCardProps {
  data?: TransactionReportsEcologyStatisticsModel;
}

export const EmissionsAvoidedCard = ({
  data,
}: EmissionsAvoidedCardProps): React.JSX.Element => {
  const { t, i18n } = useTranslation();

  return (
    <Card flex={1}>
      <Stack gap={GapEnum.L} direction="column">
        <AccentTitle
          as={HeadingEnum.H2}
          icon="cloud-blank-01"
          text={t('$.statistics.emissions-avoided.title')}
        />
        <Stack
          alignItems="center"
          gap={GapEnum.M}
          justifyContent="space-between">
          <Stack
            alignItems="center"
            className={classNames([
              css.highlighted,
              css[`highlighted-primary`],
            ])}
            direction="row"
            flex={1}
            gap={GapEnum.M}
            justifyContent="space-between">
            <Stack
              alignItems="center"
              gap={GapEnum.XS}
              flex={1}
              justifyContent="flex-start">
              <Text fontSize={TextFontSize.Large}>
                {t('$.statistics.emissions-avoided.CO2')}
              </Text>
            </Stack>
            <Text bold fontSize={TextFontSize.Large}>
              {data
                ? `${toNumberString(data.CO2, i18n.language, 0, 0)} t`
                : '-'}
            </Text>
          </Stack>
          <Stack
            alignItems="center"
            className={classNames([
              css.highlighted,
              css[`highlighted-primary`],
            ])}
            direction="row"
            flex={1}
            gap={GapEnum.M}
            justifyContent="space-between">
            <Stack
              alignItems="center"
              gap={GapEnum.XS}
              flex={1}
              justifyContent="flex-start">
              <Text fontSize={TextFontSize.Large}>
                {t('$.statistics.emissions-avoided.CO')}
              </Text>
            </Stack>
            <Text bold fontSize={TextFontSize.Large}>
              {data
                ? `${toNumberString(data.CO, i18n.language, 0, 0)} kg`
                : '-'}
            </Text>
          </Stack>
        </Stack>
        <Stack
          alignItems="center"
          gap={GapEnum.M}
          justifyContent="space-between">
          <Stack
            alignItems="center"
            className={classNames([
              css.highlighted,
              css[`highlighted-primary`],
            ])}
            direction="row"
            flex={1}
            gap={GapEnum.M}
            justifyContent="space-between">
            <Stack
              alignItems="center"
              gap={GapEnum.XS}
              flex={1}
              justifyContent="flex-start">
              <Text fontSize={TextFontSize.Large}>
                {t('$.statistics.emissions-avoided.NOx')}
              </Text>
            </Stack>
            <Text bold fontSize={TextFontSize.Large}>
              {data
                ? `${toNumberString(data.NOx, i18n.language, 0, 0)} kg`
                : '-'}
            </Text>
          </Stack>
          <Stack
            alignItems="center"
            className={classNames([
              css.highlighted,
              css[`highlighted-primary`],
            ])}
            direction="row"
            flex={1}
            gap={GapEnum.M}
            justifyContent="space-between">
            <Stack
              alignItems="center"
              gap={GapEnum.XS}
              flex={1}
              justifyContent="flex-start">
              <Text fontSize={TextFontSize.Large}>
                {t('$.statistics.emissions-avoided.HC')}
              </Text>
            </Stack>
            <Text bold fontSize={TextFontSize.Large}>
              {data
                ? `${toNumberString(data.hc, i18n.language, 0, 0)} kg`
                : '-'}
            </Text>
          </Stack>
        </Stack>
        <Stack
          alignItems="center"
          className={classNames([css.highlighted, css[`highlighted-primary`]])}
          direction="row"
          flex={1}
          gap={GapEnum.M}
          justifyContent="space-between">
          <Stack
            alignItems="center"
            gap={GapEnum.XS}
            flex={1}
            justifyContent="flex-start">
            <Text fontSize={TextFontSize.Large}>
              {t('$.statistics.emissions-avoided.PM')}
            </Text>
          </Stack>
          <Text bold fontSize={TextFontSize.Large}>
            {data
              ? `${toNumberString(data.pm10, i18n.language, 0, 0)} kg`
              : '-'}
          </Text>
        </Stack>
      </Stack>
    </Card>
  );
};
